import { makeModuleStateSelector } from "@client/content/selectors";
import { defaultState, previewState } from "./reducer";
import { type MemberVouchers } from "./types";

export const localStateSelector = makeModuleStateSelector<MemberVouchers.AppState>(defaultState, previewState);
